import { createSelector } from '@reduxjs/toolkit';
import { currentEmployeeUuid } from '../employees/current-employee-uuid';
import { currentContactUuid } from '../partners/current-contact-uuid';

export const currentUserUuid = createSelector(
  currentEmployeeUuid,
  currentContactUuid,
  function (employeeUuid, contactUuid): string {
    if (employeeUuid) {
      return employeeUuid;
    }
    if (contactUuid) {
      return contactUuid;
    }
    throw new Error('Illegal state');
  },
);
